/**
 * 统一的日志工具
 * 开发环境输出到控制台，生产环境可发送到日志服务
 */

const isDev = import.meta.env.DEV

/**
 * 日志工具类
 */
export const logger = {
  /**
   * 信息日志
   */
  info: (...args: unknown[]): void => {
    if (isDev) {
      console.log('[INFO]', ...args)
    } else {
      // 生产环境可以发送到日志服务
      // sendToLogService('info', args)
    }
  },

  /**
   * 警告日志
   */
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn('[WARN]', ...args)
    } else {
      // 生产环境可以发送到日志服务
      // sendToLogService('warn', args)
    }
  },

  /**
   * 错误日志
   */
  error: (...args: unknown[]): void => {
    if (isDev) {
      console.error('[ERROR]', ...args)
    } else {
      // 生产环境必须发送到日志服务
      // sendToLogService('error', args)
    }
  },

  /**
   * 调试日志（仅在开发环境）
   */
  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.debug('[DEBUG]', ...args)
    }
  }
}

/**
 * 发送日志到远程服务（生产环境使用）
 */
// function sendToLogService(level: string, args: unknown[]): void {
//   // TODO: 实现日志服务集成
//   // 例如：发送到 Sentry、LogRocket 等
// }

export default logger

